import type {ClientLogDeviceMeta} from './client-log-contract'
import {isFacebookInAppBrowserUserAgent} from './meta-in-app-browser'

const BOT_USER_AGENT_PATTERN = /(bot|crawler|spider|headless|preview|slurp)/i
const TABLET_USER_AGENT_PATTERN = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i
const MOBILE_USER_AGENT_PATTERN = /(mobi|iphone|ipod|android.*mobile|windows phone)/i
const DESKTOP_USER_AGENT_PATTERN = /(windows nt|macintosh|linux|x11)/i
const IOS_DEVICE_PATTERN = /(iphone|ipad|ipod)/i
const IPAD_OS_DESKTOP_PATTERN = /macintosh/i

const resolveIsIPadOSDesktop = (userAgent: string, touchPoints?: number): boolean => (
    IPAD_OS_DESKTOP_PATTERN.test(userAgent) && (touchPoints ?? 0) > 1
)

export const resolveIsIOS = (userAgent: string, touchPoints?: number): boolean => {
    if (IOS_DEVICE_PATTERN.test(userAgent)) return true
    return resolveIsIPadOSDesktop(userAgent, touchPoints)
}

export const resolveDeviceType = (
    userAgent: string,
    touchPoints?: number,
): ClientLogDeviceMeta['deviceType'] => {
    if (!userAgent) return 'unknown'

    if (BOT_USER_AGENT_PATTERN.test(userAgent)) return 'bot'
    if (TABLET_USER_AGENT_PATTERN.test(userAgent) || resolveIsIPadOSDesktop(userAgent, touchPoints)) return 'tablet'
    if (MOBILE_USER_AGENT_PATTERN.test(userAgent)) return 'mobile'
    if (DESKTOP_USER_AGENT_PATTERN.test(userAgent)) return 'desktop'
    return 'unknown'
}

export const resolveOsFamily = (userAgent: string, touchPoints?: number): string => {
    if (!userAgent) return 'other'
    if (resolveIsIOS(userAgent, touchPoints)) return 'ios'
    if (/android/i.test(userAgent)) return 'android'
    if (/windows nt/i.test(userAgent)) return 'windows'
    if (/macintosh|mac os x/i.test(userAgent)) return 'macos'
    if (/linux|x11/i.test(userAgent)) return 'linux'
    return 'other'
}

export const resolveBrowserFamily = (userAgent: string): string => {
    if (!userAgent) return 'other'
    if (isFacebookInAppBrowserUserAgent(userAgent)) return 'facebook_iab'
    if (/edg\//i.test(userAgent)) return 'edge'
    if (/firefox|fxios/i.test(userAgent)) return 'firefox'
    if (/chrome|crios/i.test(userAgent) && !/edg\//i.test(userAgent) && !/opr\//i.test(userAgent)) return 'chrome'
    if (/safari/i.test(userAgent) && !/chrome|crios|android/i.test(userAgent)) return 'safari'
    return 'other'
}
